'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _codedmedicalrecords = require('./codedmedicalrecords.html');

var _codedmedicalrecords2 = _interopRequireDefault(_codedmedicalrecords);

var _codedmedicalrecords3 = require('./codedmedicalrecords.controller');

var _codedmedicalrecords4 = _interopRequireDefault(_codedmedicalrecords3);

require('./codedmedicalrecords.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var codedmedicalrecordsComponent = {
  restrict: 'E',
  bindings: {},
  template: _codedmedicalrecords2.default,
  controller: _codedmedicalrecords4.default,
  controllerAs: 'vm'
};

exports.default = codedmedicalrecordsComponent;


// WEBPACK FOOTER //
// ./client/app/common/reports/codedmedicalrecords/codedmedicalrecords.component.js